<template>
  <v-container fluid>
    <v-card flat class="my-5 elevation-0" height="100%">
      <v-card-title>
        Current Transcript
        <v-spacer />
        <v-btn small color="primary" @click="downloadLink(file)">
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-row>
        <v-col cols="8" offset="2">
          <v-card-text class="elevation-1 my-1">
            <pdf style="width: 100%" :src="file" />
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import pdf from "vue-pdf";
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";
import { AuthService } from "@/packages/dashboard/modules/auth";
export default {
  name: "examTranscriptCard",
  mixins: [FileMixin],
  components: { pdf },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.dispatch("Exam/transcripts", {
        studentNo: AuthService.user.student_no,
      });
    });
  },
  data: function () {
    return {
      file: "",
    };
  },
  computed: {
    transcript() {
      return this.$store.getters["Exam/studentExamGetter"]("transcript");
    },
  },
  watch: {
    transcript() {
      console.log(this.transcript);
      if (this.transcript.isFile) {
        this.file = process.env.VUE_APP_TEMP_URL + this.transcript.res;
      } else {
        this.$alert({
          title: "Unable to display results",
          text: this.transcript.res,
          onClose: () => {
            this.$router.replace({ path: "/" });
          },
        });
      }
    },
  },
};
</script>

<style scoped></style>
